var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavbarLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 356.501,
    height: 349.713,
    viewBox: "0 0 356.501 349.713",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vip-03",
    transform: "translate(-147.58 -177.752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M312.205,275.25l-52.163,12.08-7.293,16.579,52.1-12.054Z",
    transform: "translate(32.772 30.382)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M258.7,311.587l-20.343,46.3L212.2,420.254l18.572,64.7,12.67-30.206,67.43-155.229Z",
    transform: "translate(20.136 37.944)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M275.541,289.627l-52.5,12.146-25.878,57.645-4.027-14.008-9.994-34.8-.118.039-8.63-30.062-26.809,61,18.782,65.436,4.394,15.307-.079.2,18.835,65.581L215.9,425.2l59.613-135.529Z",
    transform: "translate(0 32.046)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M352.859,178A141.654,141.654,0,0,0,204.87,295.9l57.606-13.339a89.95,89.95,0,1,1,82.3,126.78l52.045-119.776L344.78,301.6l-42.772,97.322-26.39,62.957,18.822,65.581,28.646-68.073c4.328.656,8.735,1.141,13.195,1.4a141.648,141.648,0,1,0,16.58-282.81Z",
    transform: "translate(17.852)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarLogo);
export default __webpack_public_path__ + "static/media/NavbarLogo.7d50e2c12e84c1fa3f61b259adf24307.svg";
export { ForwardRef as ReactComponent };